import apiCall from "auth/ApiCallInstance";
import { urlBase64ToUint8Array } from "../utils/pushClient";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "constants/AuthConstant";

const API = API_BASE_URL;

// Wait for authentication token to be available
async function waitForAuth(maxWait = 10000) {
  const startTime = Date.now();
  while (Date.now() - startTime < maxWait) {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) {
      console.log("[push] Auth token found");
      return true;
    }
    await new Promise(resolve => setTimeout(resolve, 100));
  }
  console.warn("[push] Auth token not found after waiting");
  return false;
}

export async function enablePushForAdmin() {
  try {
    console.log("[push] start");

    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      console.log("[push] not supported");
      return;
    }

    // Wait for authentication before proceeding
    const hasAuth = await waitForAuth();
    if (!hasAuth) {
      console.log("[push] No auth token, skipping push subscription");
      return;
    }

    const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    await navigator.serviceWorker.ready;

    if (!navigator.serviceWorker.controller) {
      await new Promise((resolve) => {
        navigator.serviceWorker.addEventListener("controllerchange", resolve, { once: true });
      });
    }

    console.log("[push] sw ready + controlling");

    const perm = await Notification.requestPermission();
    console.log("[push] permission:", perm);
    if (perm !== "granted") return;

    const { data } = await apiCall.get(`${API}/push/public-key`);
    console.log("[push] got public key", data?.publicKey?.slice(0, 12) + "...");
    const publicKey = data.publicKey;

    let sub = await reg.pushManager.getSubscription();
    console.log("[push] existing sub?", !!sub);

    if (!sub) {
      try {
        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(publicKey),
        });
        console.log("[push] subscribe OK");
      } catch (e) {
        console.error("[push] subscribe FAIL:", e);
        return;
      }
    }

    // ✅ Convert to clean JSON before sending
    const plainSub = sub.toJSON ? sub.toJSON() : JSON.parse(JSON.stringify(sub));
    console.log("[push] plainSub:", plainSub);

    console.log("[push] posting subscription to server...");
    try {
      const r = await apiCall.post(`${API}/push/subscribe`, plainSub);
      console.log("[push] server saved:", r?.data);
    } catch (e) {
      console.error("[push] POST /subscribe failed:", e?.response?.data || e);
      // If 401, token might have expired - wait a bit and retry once
      if (e?.response?.status === 401) {
        console.log("[push] Got 401, waiting for token refresh and retrying...");
        await new Promise(resolve => setTimeout(resolve, 2000));
        try {
          const retry = await apiCall.post(`${API}/push/subscribe`, plainSub);
          console.log("[push] server saved (retry):", retry?.data);
        } catch (retryError) {
          console.error("[push] Retry also failed:", retryError?.response?.data || retryError);
          return;
        }
      } else {
        return;
      }
    }

    console.log("[push] done ✅");
  } catch (e) {
    console.error("[push] unexpected error:", e);
  }
}
